const globalConfig = {
      serverUrl: "/api/development",
      localUrl: 'https://ads.dongkuntech.cn',
     /* serverUrl: 'https://test-api.dongkuntech.cn/api/v1',
       localUrl: 'http://localhost:3000',*/
     // serverUrl: "http://server-dev.adseasy.com/api/v1",
}
export default globalConfig
